<template>
  <div :class="['middle', mainBlockStyles, { readonly }]">
    <mainBlock :readonly="readonly"/>
  </div>
</template>

<script>
import mainBlock from "@/components/blocks/index.vue";
import { screenSizes } from '@/config/screen-sizes.js'
import { mapGetters } from "vuex"

export default {
  props: ['readonly'],
  components: { mainBlock },
  data () {
  	return {
  		screenSizes,
  	}
  },
  computed: {
    ...mapGetters("landing", ["landingSettings"]),
    currentSizeIndex() {
    	return screenSizes?.findIndex(item => item.title === this.landingSettings?.size?.width + 'px');
    },
    mainBlockStyles () {
    	if(this.readonly) return ''
      let ind = screenSizes?.findIndex(item => item.title === this.landingSettings?.size?.width + 'px');
      if (ind === 0) return 'middle-large'
      if (ind === 1) return 'middle-normal'
      if (ind === 2) return 'middle-small'
      return ''
    }
  }
}
</script>

<style scoped>
.middle {
	width: calc(100% - 44%);
	margin: auto;
	padding: 2rem;
	min-height: 100vh;
	overflow-y: scroll;
	height: 100%;
	position: relative;
	padding-bottom: 5rem;
	padding-top: 5rem;
}

.middle.readonly {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
}

.middle-large {
	width: calc(100% - 44%);
	width: calc(100% - 30%);
	transform: scale(.8);
	transform-origin: top;
	padding-top: 8rem;
}

.middle-normal {
	width: calc(100% - 50%)
}
.middle-small {
	width: calc(100% - 60%)
}

@media (max-width: 768px) {
  .middle {
  	width: 100%;
  	margin: 0;
  	padding: 0;
		padding-top: 3.1rem;
  }
}
</style>